var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 9 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m7.931 2.68-2.283-.333L4.628.278a.5.5 0 0 0-.897 0l-1.02 2.069-2.283.333a.5.5 0 0 0-.276.853l1.651 1.61-.39 2.273a.5.5 0 0 0 .725.526L4.18 6.87l2.042 1.073a.5.5 0 0 0 .725-.526l-.39-2.274 1.65-1.61a.5.5 0 0 0-.276-.852m-2.18 2.2.37 2.162-1.941-1.02-1.942 1.02.37-2.162-1.572-1.532 2.172-.315.972-1.969.972 1.969 2.171.315z"
})));
export default SvgStar;